import React from 'react'
import cx from 'classnames'

import s from './HeaderNavItem.scss'


const HeaderNavItem = ({ children, className, id, dataTestId }) => (
  <li className={cx(s.navItem, className)} id={id} data-testid={dataTestId} role="none">
    {children}
  </li>
)


export default HeaderNavItem
